import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { JobListActions } from './store/job-list/job-list.actions';
import {
	ActivatedRoute,
	NavigationEnd,
	NavigationStart,
	Router
} from '@angular/router';
import { GenericActions } from './store/generic.actions';
import { IpDetectorActions } from './store/ip-detector/ip-detector.action';
import { environment } from '../environments/environment';
import { GenericService } from './services/generic.service';
import { Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { SITE_DATA } from '../app/productization/default.constant';
import { IpDetectorState } from './store/ip-detector/ip-detector.state';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
	public preloader: any = {
		bgsColor: '#9f9a9a',
		bgsOpacity: 0.5,
		bgsPosition: 'bottom-right',
		bgsSize: 60,
		bgsType: 'ball-spin-clockwise',
		blur: 5,
		delay: 0,
		fastFadeOut: true,
		fgsColor: '#ffffff',
		fgsPosition: 'center-center',
		fgsSize: 0,
		fgsType: 'rotating-plane',
		gap: 73,
		logoPosition: 'center-center',
		logoSize: 140,
		logoUrl: 'assets/images/preloader2.gif',
		masterLoaderId: 'master',
		overlayBorderRadius: '0',
		overlayColor: 'rgba(40,40,40,0.65)',
		pbColor: '#5b91ee',
		pbDirection: 'ltr',
		pbThickness: 3,
		hasProgressBar: true,
		text: '',
		textColor: '#FFFFFF',
		textPosition: 'center-center',
		maxTime: -1,
		minTime: 300
	};
	public _featureFlagSubscription: any;
	public isResumePreview: boolean = false;
	public isSignUpQuestions: boolean = false;
	private readonly metaService = inject(Meta);
	private readonly store = inject(Store);
	private readonly router = inject(Router);
	private readonly route = inject(ActivatedRoute);
	private readonly genericService = inject(GenericService);
	public siteData = SITE_DATA;
	private readonly document = inject(DOCUMENT);
	private readonly destroyRef = inject(DestroyRef);
	public isSiteUnderConstruction: boolean;
	private readonly getIpAddress = this.store.select(IpDetectorState.getIp);

	constructor() {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.isResumePreview = event.url?.split('/')[1] === 'resume-preview';

				if (event.url.split('/')[1] === 'customer-view') {
					window.location.replace(environment.baseJobs2Url + this.router.url);
				}

				if (event.url.split('/')[1] === 'questions') {
					this.isSignUpQuestions = true;
				}

				if (event.url.split('?')[0] === '/') {
					this.route.queryParams.subscribe((params: any) => {
						if (params.ref) {
							this.genericService
								.put('Applicant/AddReferCampaignClicks/' + params.ref, null)
								.subscribe(() => {});
						}
					});
				}
			}
		});
	}

	ngOnInit(): void {
		this.loadNewRelicScript();
		this.store.dispatch([
			new GenericActions.GetCountries(),
			new GenericActions.GetCategories(),
			new IpDetectorActions.GetIp()
		]);

		if (!environment.production) {
			this.metaService.updateTag({
				name: 'robots',
				content: 'noindex, nofollow'
			});
		}

		this.route.fragment.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((fragment) => {
			if (fragment === 'create-account') {
				this.store.dispatch(new GenericActions.ToggleRegistration());
			}
		});

		this.document
			.getElementById('favicon')
			?.setAttribute('href', this.siteData.favIcon);
		this.document
			.getElementById('faviconType')
			?.setAttribute('href', this.siteData.favIcon);

		this.preloader.logoUrl = this.siteData.preloader;

		this.getIpAddress.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
			next: (res) => {
				if (res) {
					if (
						res.ip === '161.49.194.83' ||
						res.ip === '122.53.216.50' ||
						!environment.siteUnderConstruction
					) {
						this.isSiteUnderConstruction = false;
					} else {
						this.isSiteUnderConstruction = true;
					}
				}
			},
			error: (err) => {
				console.error('Error fetching IP address:', err);
			}
		});
	}

	onScrollDown() {
		if (this.router.url.split('?')[0] === '/job-list') {
			this.store.dispatch(new JobListActions.GetMoreJobList());
		}
	}

	public loadNewRelicScript() {
		(window as any).__newRelicAppID = environment.NewRelicAppID;

		/* Create your script */
		const body = <HTMLDivElement>document.body;
		const script = document.createElement('script');
		script.src = './assets/js/new-relic.js';
		/* add your script to DOM */
		body.appendChild(script);
	}

	// Preparation for CSUID
	// private checkCurrentRoute(currentUrl: string) {
	// 	// AppCommon.logReferClicks(this.checkCurrentRoute(event.url));
	// 	if (currentUrl.split('?')[0] === '/') {
	// 		return 'Landing Page';
	// 	} else if (currentUrl.split('?')[0] === '/job-list') {
	// 		return 'Job List Page';
	// 	} else {
	// 		let checkRoute = currentUrl.split('/');
	// 		if (checkRoute.length === 2) {
	// 			return checkRoute[1].charAt(0).toUpperCase() + checkRoute[1].slice(1) + ' Page';
	// 		} else {
	// 			return checkRoute[1].charAt(0).toUpperCase() + checkRoute[1].slice(1) + ': JR-' + checkRoute[2];
	// 		}
	// 	}
	// }
}
